import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { themeManager } from './utils/themeManager';


import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AuthCallback from './components/AuthCallback';
import Archive from './components/Archive';
import Inventory from './components/Inventory';
import XpLeaderboard from './components/XpLeaderboard';
import SSORedirect from './components/SSORedirect';
import DonatePage from './components/DonatePage';
import AdminStatsDashboard from './components/AdminStatsDashboard';

const applyWallpaper = themeManager.applyWallpaper;
// Простой компонент для защиты роутов
function PrivateRoute({ children }) {
  const token = localStorage.getItem('hatchup_token');
  // Если токен есть, показываем дочерний компонент (Dashboard), иначе - перенаправляем на логин
  return token ? children : <Navigate to="/login" />;
}

function App() {
  useEffect(() => {
    const savedTheme = localStorage.getItem('hatchup_theme') || 'default';
    const savedBgMode = localStorage.getItem('hatchup_bg_mode') || 'none';
    const savedCustomUrl = localStorage.getItem('hatchup_custom_bg_url') || '';
    const savedBgDim = Number(localStorage.getItem('hatchup_bg_dim') ?? 65);

    if (savedTheme === 'default') {
      document.documentElement.removeAttribute('data-theme');
    } else {
      document.documentElement.setAttribute('data-theme', savedTheme);
    }

    applyWallpaper(savedTheme, savedBgMode, savedCustomUrl, savedBgDim);
  }, []);
  return (
    <div className="App">

      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/donate/:userId" element={<DonatePage />} />
          <Route path="/inventory" element={<PrivateRoute><Inventory /></PrivateRoute>} />
          <Route path="/leaderboard-xp" element={<PrivateRoute><XpLeaderboard /></PrivateRoute>} />
          <Route path="/sso" element={<SSORedirect />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/archive"
            element={
              <PrivateRoute>
                <Archive />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stats"
            element={
              <PrivateRoute>
                <AdminStatsDashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;